export const filterZeroPrices = (prices) => {
  if (prices.length === 1 && parseFloat(prices[0].price) < 1) {
    return prices
  }
  return prices.filter(({price}) => parseFloat(price) > 0)
}



// WEBPACK FOOTER //
// ./src/helpers.js